<app-response-banner
[invisible]="!fail"
[errorMessage]="'Something went wrong, try again later'"
[success]="false"
>
</app-response-banner>
